import { IonButton, IonIcon } from "@ionic/react";
import { chevronBack, chevronForward, searchOutline } from "ionicons/icons";
import { formatDate } from "../utils/date.js";

export default function DateNavigator({ date, onChange, onSearch }) {
  return (
    <div className="date-nav">
      <div className="date-nav-controls date-nav-controls-start">
        <IonButton fill="clear" onClick={() => onChange(-1)} aria-label="Previous day">
          <IonIcon icon={chevronBack} />
        </IonButton>
        <IonButton fill="clear" onClick={onSearch} aria-label="Search scheduled occurrences">
          <IonIcon icon={searchOutline} />
        </IonButton>
      </div>
      <div className="date-nav-current">{formatDate(date)}</div>
      <div className="date-nav-controls date-nav-controls-end">
        <IonButton className="date-nav-today" fill="clear" onClick={() => onChange(0)}>
          Today
        </IonButton>
        <IonButton fill="clear" onClick={() => onChange(1)} aria-label="Next day">
          <IonIcon icon={chevronForward} />
        </IonButton>
      </div>
    </div>
  );
}
